import { render, staticRenderFns } from "./ListaPreembarques.vue?vue&type=template&id=53332df6&scoped=true&"
import script from "./ListaPreembarques.vue?vue&type=script&lang=js&"
export * from "./ListaPreembarques.vue?vue&type=script&lang=js&"
import style0 from "./ListaPreembarques.vue?vue&type=style&index=0&id=53332df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53332df6",
  null
  
)

export default component.exports